import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useRefreshAction } from "@/features/dashboard/features/refresh-timer/hooks";

import {
  riskPictureLegacyCommentKey,
  riskPictureLegacyCommentQuery,
} from "./risk-picture-legacy-comment";

/**
 * Legacy "toelichting" comment. Fetched on mount and re-fetched on every page
 * refresh (manual + auto-refresh interval), like the widgets on the page, so the
 * dialog always opens with current text. Outside the refresh provider this only
 * reads the cache.
 */
export function useRiskPictureLegacyCommentQuery() {
  const queryClient = useQueryClient();

  const refresh = useCallback(async () => {
    await queryClient.refetchQueries({ queryKey: riskPictureLegacyCommentKey() });
  }, [queryClient]);
  useRefreshAction(refresh);

  return useQuery(riskPictureLegacyCommentQuery());
}
